import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import * as moment from "moment";
import "moment-timezone";
import { getRequestDetailsById, logList } from "../../../services/userservice";
import {
  setLogList,
  setLoading as setBookingLoading,
  setError,
} from "../../../features/common/logSlice";

import { Button, Modal } from "react-bootstrap";

const LogRequest = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [bookingsPerPage] = useState(25);
  const [searchTerm, setSearchTerm] = useState("");
  const { loglists, loading, error } = useSelector((state) => state.loglists);
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const [requestData, setRequestData] = useState();

  const dispatch = useDispatch();
  useEffect(() => {
    const fetchBookingData = async () => {
      try {
        dispatch(setBookingLoading());
        const response = await logList();
        dispatch(setLogList(response.data));
      } catch (error) {
        dispatch(setError(error.message));
      }
    };
    fetchBookingData();
  }, [dispatch]);

  const fetchRequestResponseData = (id) => {
    getRequestDetailsById(id)
      .then((response) => {
        setRequestData(response);
        setShowModal(true);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  if (loading) return <div>Loading...</div>;

  if (error) return <div>Error: {error}</div>;

  const filteredbookings = loglists?.filter(
    (booking) =>
      booking?.swt_booking_id
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      booking?.vendor_type?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      booking?.type?.toLowerCase().includes(searchTerm.toLowerCase())
  );




  // Table rows to show per page Start

  const indexOfLastBooking = currentPage * rowsPerPage;
  const indexOfFirstBooking = indexOfLastBooking - rowsPerPage;
  const currentBookings = filteredbookings.slice(indexOfFirstBooking, indexOfLastBooking);


  // bottom pagination start

  const totalPages = Math.ceil(filteredbookings.length / rowsPerPage);


  const renderPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 3;

    if (totalPages <= 10) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first 3 pages
      pages.push(1, 2, 3);

      // Show "..." if currentPage is beyond 5
      if (currentPage > 5) {
        pages.push("...");
      }

      // Show current page and neighbors
      const start = Math.max(4, currentPage - 1);
      const end = Math.min(totalPages - 3, currentPage + 1);

      for (let i = start; i <= end; i++) {
        if (!pages.includes(i)) pages.push(i);
      }

      // Show "..." if currentPage is far from end
      if (currentPage < totalPages - 4) {
        pages.push("...");
      }

      // Always show last 3 pages
      pages.push(totalPages - 2, totalPages - 1, totalPages);
    }

    return pages.map((page, index) => (
      <li
        key={index}
        className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
      >
        {page === "..." ? (
          <span className="page-link">...</span>
        ) : (
          <button className="page-link" onClick={() => setCurrentPage(page)}>
            {page}
          </button>
        )}
      </li>
    ));
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Log List</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item active">Dashboard</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title"></h3>
                  <div className="d-flex align-items-center justify-content-end">
                    <div className="card-tools">
                      <div
                        className="input-group input-group-sm"
                        style={{ width: "250px" }}
                      >
                        <input
                          type="text"
                          name="table_search"
                          className="form-control float-right"
                          placeholder="Search"
                          value={searchTerm}
                          onChange={handleSearchChange}
                        />
                        <div className="input-group-append">
                          <button type="submit" className="btn btn-default">
                            <i className="fas fa-search" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card-body">

                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <label className="me-2">Show</label>
                      <select
                        value={rowsPerPage}
                        onChange={(e) => {
                          setRowsPerPage(parseInt(e.target.value));
                          setCurrentPage(1); // Reset to first page
                        }}
                        className="form-control mx-2 form-select d-inline-block w-auto"
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      <span className="ms-2">entries</span>
                    </div>
                    <div>
                      {/* Optional: Add search or pagination controls here */}
                    </div>
                  </div>

                  <div className="table-responsive">
                    <table className="table table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>Booking ID</th>
                          <th>Booking Date</th>
                          <th>Vendor Type</th>
                          <th>Type</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      {filteredbookings.length > 0 ? (
                        <tbody>
                          {currentBookings.map((booking) => (
                            <tr key={booking.id}>
                              <td>{booking?.swt_booking_id}</td>
                              <td>
                                {moment
                                  .utc(booking?.created_at)
                                  .tz("Asia/Kolkata")
                                  .format("DD-MM-YY hh:mm A")}
                              </td>
                              <td>{booking?.vendor_type?.toUpperCase()}</td>
                              <td>{booking?.type?.toUpperCase()}</td>

                              <td>
                                <button
                                  onClick={() =>
                                    fetchRequestResponseData(booking?.id)
                                  }
                                  className="btn btn-primary btn-sm"
                                >
                                  View
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <div className="text-center p-3">
                          <h5 style={{ color: "red", textAlign: "center" }}>
                            No Log found
                          </h5>
                        </div>
                      )}
                    </table>
                  </div>

                  <div className="d-md-flex justify-content-between align-items-center mt-3">
                    <div>
                      Showing {indexOfFirstBooking + 1} to {Math.min(indexOfLastBooking, filteredbookings.length)} of {filteredbookings.length} entries
                    </div>
                    <nav>
                      <ul className="pagination mb-0">
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                          <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                            Previous
                          </button>
                        </li>

                        {renderPageNumbers()}

                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                          <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>

                </div>


              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        size="lg"
        className="custom-enquiry-modal"
      >
        <Modal.Header>
          <Modal.Title className="d-flex align-items-center">
            <i
              className="fa fa-envelope-open-text text-primary mx-2"
              style={{ color: "#fff" }}
            ></i>
            Log Details
          </Modal.Title>
          <i
            className="fa fa-times close-icon"
            onClick={handleCloseModal}
            role="button"
            aria-label="Close Modal"
            title="Close"
          ></i>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="modal-body-wrapper">
            <div className="enquiry-section">
              <h5 className="section-title">Request</h5>
              <br />
              <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                <code>{JSON.stringify(requestData?.request, null, 2)}</code>
              </pre>
            </div>
            <div className="enquiry-section">
              <h5 className="section-title">Response Data</h5> <br />
              <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                <code>{JSON.stringify(requestData?.response, null, 2)}</code>
              </pre>
            </div>
            <div className="enquiry-section">
              <h5 className="section-title">Timestamps</h5>
              <p>
                <strong>Created At:</strong>{" "}
                {moment
                  .utc(requestData?.created_at)
                  .tz("Asia/Kolkata")
                  .format("LLLL") ?? "N/A"}
              </p>
              <p>
                <strong>Updated At:</strong>{" "}
                {moment
                  .utc(requestData?.updated_at)
                  .tz("Asia/Kolkata")
                  .format("LLLL") ?? "N/A"}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button variant="primary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default LogRequest;
